import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_STATUS } from '../../Store/AssetManagement/Status/StatusType'
import { setStatus } from 'Store/AssetManagement/Status/StatusAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';


function* getStatus() : any {
let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/dispositions`,
        payload : null       
    }
    try {
        yield put(globalLoaderText("Fetching Status...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if(response?.length > 0){
        const defaultStatusOption = {
            text: "Select Status",
            value: null
        };
        response.unshift(defaultStatusOption);
    }
        yield put(setStatus(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setStatus([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetStatus() {
    yield takeEvery(GET_STATUS, getStatus)
}

export default function* combinedSaga() {
    yield all([
        watchGetStatus()
    ])
}
